var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('div',[_vm._v(_vm._s(new Date().getFullYear())+" © TuneSoft")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }